import { AxiosResponse } from "axios";
import { EmteriaRoles } from "src/data/roles";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { BasicApiResponse, PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export type FetchAccountsPayload = {
    HasRoles?: boolean;
    ExcludeDeleted?: boolean;
    SortCriteria?: string;
    SortDirection?: 0 | 1 | -1;
    PageIndex?: number;
    PageSize?: number;
};
export async function fetchAccounts(payload?: FetchAccountsPayload) {
    try {
        const endpoint = await RouteService.getAdminAccountsRoute();
        const { data } = await HttpService.get<PaginatedResponse<API.Account>>(endpoint + "all", {
            params: {
                ...payload,
                PageIndex: (payload?.PageIndex ?? 0) + 1,
            },
        });
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function fetchRoles() {
    try {
        const endpoint = await RouteService.getSecurityRoute();
        const { data } = await HttpService.get<PaginatedResponse<EmteriaRoles>>(endpoint + "roles");
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

type AssignRolePayload = {
    id: string;
    role: string;
};
export async function assignRole(payload: AssignRolePayload) {
    try {
        const endpoint = await RouteService.getAdminAccountsRoute();
        const { data } = await HttpService.post(endpoint + `${payload.id}/roles`, {
            role: payload.role,
        });
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

type RemoveRolePayload = {
    id: string;
    role: string;
};
export async function removeRole(payload: RemoveRolePayload) {
    try {
        const endpoint = await RouteService.getAdminAccountsRoute();
        const { data } = await HttpService.delete(endpoint + `${payload.id}/roles/${payload.role}`);
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}

export type DeleteAccountPayload = {
    id: string;
    fullDeletion: boolean;
    sendNotification: boolean;
};
export async function deleteAccount({ id, ...params }: DeleteAccountPayload) {
    try {
        const endpoint = await RouteService.getAdminAccountsRoute();
        const { data } = await HttpService.delete<string, AxiosResponse<BasicApiResponse>>(endpoint + id, { params });
        return data;
    } catch (error) {
        throw unpackError(error);
    }
}
